import Image from "next/image";
import CTALink from "@/components/CTA/ctaLink";
import LocalizedOfferEndsPrefix from "@/components/PromoBanner/components/LocalizedOfferEndsPrefix";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerDefault({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDate,
  endDatePrefix,
  image,
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div className={`flex flex-col md:flex-row bg-primary ${className || ""}`}>
      <div className="px-8 py-20 md:pl-20 lg:pl-32 lg:py-32 lg:basis-3/5">
        <h2 className="elm-d1 text-primary-foreground italic mt-0 mb-8">
          {title}
        </h2>
        <p className="text-primary-foreground elm-p5 mb-8">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <span>
              Get <strong>up to {discount} off</strong> with code{" "}
              <strong>{discountCode}</strong>.
            </span>
          )}{" "}
          <LocalizedOfferEndsPrefix prefix={endDatePrefix} date={endDate} />.
          <span className="inline-block">
            <PromoBannerTooltip
              discountCode={discountCode}
              endDate={endDate}
              learnMoreLink={learnMoreLink}
              htmlContent={tooltip?.infoText ?? ""}
            />
          </span>
        </p>
        {cta && !ctaElement && (
          <CTALink
            type="primaryOutline"
            size="xl"
            className="bg-white"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        )}
        {ctaElement}
      </div>
      {image?.url && (
        <div className="hidden lg:block relative clip-slant-left basis-2/5">
          <Image
            src={image.url}
            alt={image.altText || ""}
            style={{ objectFit: "cover" }}
            fill
          />
        </div>
      )}
    </div>
  );
}
